import { render } from "./InplayUpcomingEventsList.vue?vue&type=template&id=a1a00950&scoped=true"
import script from "./InplayUpcomingEventsList.vue?vue&type=script&lang=js"
export * from "./InplayUpcomingEventsList.vue?vue&type=script&lang=js"

import "./InplayUpcomingEventsList.vue?vue&type=style&index=0&id=a1a00950&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a00950"]])

export default __exports__